import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "handel-status" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { key: 6 }
const _hoisted_10 = { key: 7 }
const _hoisted_11 = { key: 8 }
const _hoisted_12 = { key: 9 }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 10 }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { key: 11 }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { key: 12 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { key: 14 }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { key: 15 }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { key: 16 }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { key: 17 }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { key: 18 }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { key: 19 }
const _hoisted_31 = ["innerHTML"]

import { t } from '@/plugins/i18n'
import { ref, computed, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: ['rowItem'],
  setup(__props) {

const props = __props

//  翻译转换
const cT = computed(() => {
  const { type, orderType, customerOperateType } = props.rowItem
  const defaultObj: any = {
    取消商品: t('取消商品采购'), // 囤货
    换个链接: t('请在我指定的新链接下采购'),
    同款链接: t('请在THE CKB为我推荐的此链接下采购'),
    等待原链接: t('可以等待，请继续在原链接采购'),
    类似款链接: t('请在THE CKB为我推荐的此链接下采购'),
    下单原链接: t('我接受起订量，请继续在原链接采购'),
    '下单原链接（多出数量保留库存）': t('我接受起订量，请继续在原链接采购'),
    良品入库: t('问题不大，我能接受，请当成良品入库'),
    不良品: t('此问题我不能接受，请依然当成不良品处理')
  }
  defaultObj['取消商品'] = orderType === 2 ? t('取消商品采购') : t('取消商品采购+商品发送')
  // 商品确认
  if (type === 1) {
    defaultObj['换个链接'] = t('请在我指定的新链接购买')
  }
  // 全网断货
  if (type === 2) {
    defaultObj['换个链接'] = t('我有可能有货的采购链接，请在这个链接再尝试购买')
  }
  // 预售商品
  if (type === 4) {
    defaultObj['换个链接'] = t('我等不及，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('我等不及，请在THE CKB为我推荐的此链接下采购')
  }
  // 不满足最小起订量
  if (type === 5) {
    defaultObj['换个链接'] = t('我不接受起订量，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('我不接受起订量，请在THE CKB为我推荐的此链接下采购')
    defaultObj['下单原链接'] = t('我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）')
  }
  // 更换同款链接
  if (type === 6) {
    defaultObj['换个链接'] = t('THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('请在THE CKB为我推荐的此链接下采购')
    defaultObj['下单原链接'] = t('我还是要继续在原链接采购')
  }
  // 次品
  if (type === 7) {
    defaultObj['取消商品'] = orderType === 2 ? t('次品退货退款并取消商品采购') : t('次品退货退款并取消商品采购+商品发送')
    if (customerOperateType !== 0) {
      // 异常处理完查看详情type 8 会转为7
      defaultObj['换个链接'] = t('此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买')
      defaultObj['取消商品'] = orderType === 2 ? t('此问题我不能接受，请依然当成不良品处理，并取消商品采购') : t('此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送')
    }
  }
  // 异常
  if (type === 8) {
    defaultObj['换个链接'] = t('此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买')
    defaultObj['取消商品'] = orderType === 2 ? t('此问题我不能接受，请依然当成不良品处理，并取消商品采购') : t('此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送')
  }
  // 倒错货
  if (type === 10) {
    defaultObj['换个链接'] = t('THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购')
    defaultObj['取消商品'] = orderType === 2 ? t('取消商品重拍') : t('取消商品重拍+商品发送')
  }
  // 少件
  if (type === 12) {
    defaultObj['取消商品'] = orderType === 2 ? t('取消商品重拍') : t('取消商品重拍+商品发送')
  }
  return (t: any) => {
    return defaultObj[t]
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.rowItem.customerOperateType == 11)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(cT)('良品入库')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 12)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(cT)('不良品')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 13)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('次品退货退款并付费重拍')) + " (" + _toDisplayString(_unref(t)('本次重拍费用X円').replace('X', __props.rowItem.remakeMoney
            || 0)) + ") ", 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 5)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(cT)('取消商品')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 14)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('按原价采购')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('更换尺码')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)('更换颜色')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 3)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)('更换款式')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 14)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('按原价采购')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 15)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
            _createElementVNode("span", {
              innerHTML: _unref(cT)('换个链接')
            }, null, 8, _hoisted_13)
          ]))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 4)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
            _createElementVNode("span", {
              innerHTML: _unref(cT)('换个链接')
            }, null, 8, _hoisted_15)
          ]))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 6)
        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
            _createElementVNode("span", {
              innerHTML: _unref(cT)('同款链接')
            }, null, 8, _hoisted_17)
          ]))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 7)
        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(cT)('类似款链接')), 1))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 8 && __props.rowItem.type === 4)
        ? (_openBlock(), _createElementBlock("span", {
            key: 13,
            innerHTML: _unref(t)('等待原链接')
          }, null, 8, _hoisted_19))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType==8&&(__props.rowItem.type === 6) || (__props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 4))
        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
            _createElementVNode("span", {
              innerHTML: _unref(cT)('下单原链接')
            }, null, 8, _hoisted_21)
          ]))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 10 && __props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 6)
        ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
            _createElementVNode("span", {
              innerHTML: _unref(cT)('下单原链接')
            }, null, 8, _hoisted_23)
          ]))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 16)
        ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('该商品取消采购和发货，订单下其余商品（若有）正常发货')
            }, null, 8, _hoisted_25)
          ]))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 17)
        ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存')
            }, null, 8, _hoisted_27)
          ]))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 18)
        ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存')
            }, null, 8, _hoisted_29)
          ]))
        : _createCommentVNode("", true),
      (__props.rowItem.customerOperateType == 19)
        ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('不能接受该不良，希望同商品换货（该换货无需重新冻结费用，如供应商无货，则系统会自动取消）')
            }, null, 8, _hoisted_31)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})